import { createWebHistory, createRouter } from "vue-router";
import { pathOf } from "@/composables/useRouteHelper";

const routes = [
  {
    path: "/:pathMatch(.*)",
    redirect: { name: "Timeline", params: {} }
  },
  {
    path: "/timeline",
    name: "Timeline",
    component: () => import("@/views/Timeline.vue"),
  },
  {
    path: "/timeline-news",
    name: "News",
    component: () => import("@/views/Timeline.vue"),
  },
  {
    path: "/timelinePAA",
    name: "TimelinePAA",
    component: () => import("@/views/Timeline.vue"),
    props: { source: 'serp', isPaaOnlyViewFromLegacy: true },
  },
  {
    path: "/timelinecompare",
    name: "Timeline Compare",
    component: () => import("@/views/TimelineCompare.vue"),
  },
  {
    path: "/timelineKP",
    name: "Knowledge Panel",
    component: () => import("@/views/TimelineKP.vue"),
  },
  {
    path: "/iresults",
    name: "iResults Manager",
    component: () => import("@/views/IResultsManager.vue"),
  },
  {
    path: "/keywordSummary",
    name: "Keyword Summary",
    component: () => import("@/views/KeywordSummary.vue"),
  },
  {
    path: "/charts",
    name: "Charts",
    component: () => import("@/views/ChartsView.vue"),
  },
 {
    path: "/clients",
    name: "Clients Manager",
    component: () => import("@/views/ClientManager.vue"),
  },
  {
    path: "/keywords",
    name: "Keywords Manager",
    component: () => import("@/views/KeywordManager.vue"),
  },
  {
    path: "/notificationsManagement",
    name: "Notifications Management Page",
    component: () => import("@/views/NotificationsManagement.vue"),
  },
  {
    path: "/notificationReports",
    name: "Notification Reports",
    component: () => import("@/views/NotificationReports.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    // MCP OAuth consent page (DM-9634): MCP clients (e.g. Claude) land here
    // from the IMPACT MCP server's /authorize redirect.
    path: "/authorize",
    name: "Authorize",
    component: () => import("@/views/Authorize.vue"),
  },
  {
  path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/ForgotPassword.vue"),
  },
  {
  path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/card-embed",
    name: "Card Embed",
    component: () => import("@/views/CardEmbed.vue"),
  },
];

routes.forEach(route => route.path = pathOf(route.path));

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;